<template>
  <div id="main" class="core-page">
    <CorePageBlokModule
      v-for="(blokModule, index) in blok.body"
      :key="index"
      :blok="blokModule"
      :blokNext="blok.body?.[index + 1]"
      :footerBlok="footerBlok"
      :hasInPageNavigationHeader="!!blok.header_in_page?.length"
      :index="index"
      :settings="settings" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { useWindow } from '@seb-platform/shared/composables';
import { useCurrentModule } from '~/composables/useCurrentModule';
import type { BmFooterStoryblok, CorePageStoryblok, CoreSettingsStoryblok } from '~/types/storyblok-generated';
import CorePageBlokModule from './CorePageBlokModule.vue';

const { clearCurrentModule } = useCurrentModule();
const { init: initWindow } = useWindow();

defineProps<{
  blok: CorePageStoryblok;
  footerBlok?: BmFooterStoryblok;
  settings: CoreSettingsStoryblok;
}>();

onMounted(() => {
  clearCurrentModule();
  initWindow();
});
</script>

<style src="./CorePage.scss" lang="scss" scoped />
